/* Product Page CRO — room size calculator */
(function () {
  function init(root) {
    if (root.dataset.croBound) return;
    root.dataset.croBound = '1';

    var models;
    try {
      models = JSON.parse(root.dataset.models || '[]').filter(Boolean);
    } catch (e) { return; }
    if (!models.length) return;
    models.sort(function (a, b) { return a.cbm - b.cbm; });

    var waBase  = root.dataset.whatsapp || '';
    var product = root.dataset.product || '';

    var preset = root.querySelector('[data-cro-preset]');
    var custom = root.querySelector('[data-cro-custom]');
    var area   = root.querySelector('[data-cro-area]');
    var height = root.querySelector('[data-cro-height]');
    var out    = root.querySelector('[data-cro-out]');

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }

    function waLink(vol, units, biggest) {
      var msg = 'Hi, I need scenting for a space of about ' + vol + ' CBM';
      if (units && biggest) {
        msg += ' (your sizing tool suggested around ' + units + ' x ' + biggest + ')';
      }
      if (product) msg += '. I was looking at the ' + product + '.';
      return waBase + '?text=' + encodeURIComponent(msg);
    }

    function show(volume) {
      if (!volume || volume <= 0) { out.hidden = true; return; }
      var vol = Math.round(volume);
      var pick = null;
      for (var i = 0; i < models.length; i++) {
        if (models[i].cbm >= vol) { pick = models[i]; break; }
      }
      var biggest = models[models.length - 1];
      var html = '<div class="cro-calc__vol">About ' + vol.toLocaleString() + ' CBM of air</div>';

      if (pick) {
        html += '<div class="cro-calc__pick">The <b>' + esc(pick.name) + '</b> covers this comfortably.</div>';
        if (models.length > 1) {
          html += '<a class="cro-calc__btn" href="?variant=' + pick.id + '">Select the ' + esc(pick.name) + '</a>';
        }
      } else {
        var units = Math.ceil(vol / biggest.cbm);
        html += '<div class="cro-calc__pick">That\u2019s beyond a single unit — you\u2019d need around ' +
                units + ' × <b>' + esc(biggest.name) + '</b>, or a ducted system.</div>';
        if (waBase) {
          html += '<a class="cro-calc__btn cro-calc__btn--wa" href="' +
                  esc(waLink(vol, units, biggest.name)) +
                  '" target="_blank" rel="noopener">' +
                  '<svg class="cro-calc__wa" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                  '<path fill="currentColor" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.18 8.18 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.19 8.19 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.79.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.5.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.47c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.14-1.18-.06-.11-.22-.17-.47-.29z"/>' +
                  '</svg>Ask us on WhatsApp</a>';
        }
      }
      out.innerHTML = html;
      out.hidden = false;
    }

    function fromCustom() {
      var a = parseFloat(area.value);
      var h = parseFloat(height.value) || 3;
      if (!a || a <= 0) { out.hidden = true; return; }
      show(a * h);
    }

    preset.addEventListener('change', function () {
      var val = preset.value;
      if (val === 'custom') {
        custom.hidden = false;
        area.focus();
        fromCustom();
      } else {
        custom.hidden = true;
        if (!val) { out.hidden = true; return; }
        show(parseFloat(val) * 3);
      }
    });

    area.addEventListener('input', fromCustom);
    height.addEventListener('input', fromCustom);
  }

  function boot() {
    document.querySelectorAll('[data-cro-calc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
